const Categories = [
  {
    cat1: [
      "Diet & Sports Nutrition Products",
      "Vitamins, Minerals & Supplements",
      "Health Care",
      "Medical Supplies & Equipment",
      "Wellness & Relaxation",
      "Oral Care",
    ],
    cat2: [
      "Activity & Entertainment",
      "Baby Care",
      "Car Seats & Accessories",
      "Diapering",
      "Feeding",
      "Gifts",
      "Nursery",
      "Potty Training",
      "Pregnancy & Maternity",
      "Safety",
      "Strollers & Accessories",
      "Travel Gear",
    ],
    cat3: {
      cat1: [
        "Fragrance",
        "Foot, Hand & Nail Care",
        "Hair Care",
        "Makeup",
        "Personal Care",
        "Salon & Spa Equipment",
        "Shave & Hair Removal",
      ],
      cat2: ["Skin Care", "Face", "Eyes", "Lip Care", "Sunscreens & Tanning Products", "Tools & Accessories"],
    },
    cat4: {
      cat1: [
        "Sports & Outdoors",
        "Musical Instruments",
        "Movies & TV",
        "Health & Household",
        "Cell Phones & Accessories",
        "Books",
        "Arts, Crafts & Sewing",
      ],
      cat2: [
        "Automotive",
        "Car Care",
        "Exterior Accessories",
        "Interior Accessories",
        "Lights, Bulbs & Indicators",
        "Motorcycle & Powersports",
        "Oils & Fluids",
        "Paint & Paint Supplies",
      ],
    },
    cat5: {
      cat1: [
        "Cell Phones & Accessories",
        "Books",
        "Office Products",
        "Office & School Supplies",
        "Office Electronics Accessories",
        "Office Furniture & Lighting",
      ],
      cat2: ["Video Games", "Mac", "Nintendo Switch", "PlayStation 4", "PlayStation 5", "Xbox Series X & S"],
      cat3: [
        "Industrial & Scientific",
        "Electronics",
        "Car & Vehicle Electronics",
        "eBook Readers & Accessories",
        "GPS, Finders & Accessories",
        "Household Batteries",
        "Chargers & Accessories",
        "Security & Surveillance",
      ],
    },
    cat6: {
      cat1: [
        "Tools & Home Improvement",
        "Kitchen & Bath Fixtures",
        "Lighting & Ceiling Fans",
        "Measuring & Layout Tools",
        "Paint, Wall Treatments & Supplies",
        "Storage & Home Organization",
      ],
      cat2: ["HOME & KITCHEN", "Grocery & Gourmet Food", "Health & Household", "Appliances", "Patio, Lawn & Garden"],
    },
    cat7: ["birds", "cats", "dogs", "Fish & Aquatic Pets", "Horses", "Reptiles & Amphibians", "Small Animals"],
  },
];

export default Categories;
